exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tree{padding-left:10px;border-left:2px solid #f5f7fa}.el-tree-node{position:relative}.el-tree-node:before{position:absolute;content:\"\";width:5px;height:5px;border-radius:50%;background:#adadad;left:-13px;top:15px}.el-tree-node>div:first-child{padding:10px!important;min-height:40px;background:#f5f7fa;margin:5px auto}", ""]);

// exports
